import { Component, Input } from '@angular/core';

/**
 * A hidden form field (`<input type="hidden">`) for native form POSTs to
 * external gateways (epay). Hidden inputs associate with their ancestor
 * `<form>` regardless of the intermediate host element, so the POST payload
 * is unchanged.
 */
@Component({
  selector: 'app-hidden-input',
  templateUrl: './hidden-input.component.html',
})
export class HiddenInputComponent {
  @Input() name = '';
  @Input() value: string | number | null = '';
}
